import { render, staticRenderFns } from "./ListAcessoPessoa.vue?vue&type=template&id=ad0b0bcc"
import script from "./ListAcessoPessoa.vue?vue&type=script&lang=js"
export * from "./ListAcessoPessoa.vue?vue&type=script&lang=js"
import style0 from "./ListAcessoPessoa.vue?vue&type=style&index=0&id=ad0b0bcc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports